// src/disc/discBrand.js
//
// SOMEREN LABS DISC MARKA SABİTLERİ — TEK KAYNAK (2026-08-18)
//
// Kaynak: ~/DISC/build_disc_share_document.py ve ondan üretilen
// "SomerenLabs_DISC_Genel_Paylasim_Belgesi_Objeler.pdf" (sayfa 3, "DISC Eksenleri").
// Paylaşım belgesi neyse rapor ve grup grafiği de odur; başka yerde renk veya
// çeyrek sırası TANIMLANMAZ, buradan okunur.
//
// ÖNCEKİ DURUM — neden bu dosya var:
//   · İki ayrı DISC paleti dolaşıyordu. Rapor #dc2626/#d49a00/#16803c/#2563eb,
//     admin dağılım grafiği #e53935/#fdd835/#43a047/#1e88e5 kullanıyordu.
//   · Çeyrek düzeni belgeyle uyuşmuyordu: hem rapor haritası hem admin grafiği
//     C sol-üst / D sağ-üst / S sol-alt / I sağ-alt diziyordu; belge ise
//     D sol-üst / I sağ-üst / C sol-alt / S sağ-alt diyor.
//   · Eksenler 90° dönüktü: rapor görev/insan ekseni DİKEYdi, belge YATAY diyor.

// ── Renkler (build_disc_share_document.py: CORAL / YELLOW / GREEN / BLUE) ────
export const DISC_RENK = {
  D: "#f26b5e", // CORAL
  I: "#f4c542", // YELLOW
  S: "#65b78f", // GREEN
  C: "#5c8ed8", // BLUE
};

// Sarı zeminde beyaz harf okunmuyor; belge de sarıda koyu mürekkep kullanıyor.
export const DISC_UZERI_YAZI = {
  D: "#ffffff",
  I: "#142033",
  S: "#ffffff",
  C: "#ffffff",
};

// ── Eksenler ────────────────────────────────────────────────────────────────
// Dikey eksen TEMPO, yatay eksen ODAK. (Belge sayfa 3.)
export const EKSENLER = {
  tr: {
    dikeyUst: "Tempo: hızlı ve doğrudan",
    dikeyAlt: "Tempo: sakin ve düşünerek",
    yatakSol: "Odak: görev / sonuç",
    yatakSag: "Odak: insan / uyum",
  },
  en: {
    dikeyUst: "Pace: fast and direct",
    dikeyAlt: "Pace: calm and considered",
    yatakSol: "Focus: task / result",
    yatakSag: "Focus: people / harmony",
  },
};

// ── Çeyrek düzeni ───────────────────────────────────────────────────────────
// Okuma sırası soldan sağa, üstten alta: D · I · C · S
export const CEYREK_DUZENI = ["D", "I", "C", "S"];

// Kartezyen dağılım grafiği için açı aralıkları (0° sağ, saat yönünün tersi).
// Çeyrekler yukarıdaki düzenle BİREBİR aynı olmalı:
//   sol-üst D → 90-180 · sağ-üst I → 0-90 · sol-alt C → 180-270 · sağ-alt S → 270-360
export const ACI_ARALIKLARI = {
  D: [90, 180],
  I: [0, 90],
  C: [180, 270],
  S: [270, 360],
};

// ── Harf içerikleri (belge sayfa 2 ve 3'ten birebir) ────────────────────────
export const HARF_ICERIK = {
  tr: {
    D: { ad: "Kararlılık", tam: "Kararlılık / Dominance", eksen: "Hızlı tempo + görev/sonuç odağı", anahtar: "Karar, yön, netlik", ses: "Sonuç!", obje: "⏱️", objeAd: "kronometre" },
    I: { ad: "Etki", tam: "Etki / Influence", eksen: "Hızlı tempo + insan/ilişki odağı", anahtar: "Enerji, görünürlük, ikna", ses: "Fikir!", obje: "📣", objeAd: "megafon" },
    C: { ad: "Titizlik", tam: "Titizlik / Conscientiousness", eksen: "Sakin tempo + görev/süreç odağı", anahtar: "Veri, kalite, standart", ses: "Veri!", obje: "📋", objeAd: "kontrol listesi" },
    S: { ad: "İstikrar", tam: "İstikrar / Steadiness", eksen: "Sakin tempo + insan/ilişki odağı", anahtar: "Güven, destek, uyum", ses: "Herkes tamam mı?", obje: "🫖", objeAd: "çaydanlık" },
  },
  en: {
    D: { ad: "Dominance", tam: "Dominance", eksen: "Fast pace + task/result focus", anahtar: "Decision, direction, clarity", ses: "Result!", obje: "⏱️", objeAd: "stopwatch" },
    I: { ad: "Influence", tam: "Influence", eksen: "Fast pace + people/relationship focus", anahtar: "Energy, visibility, persuasion", ses: "Idea!", obje: "📣", objeAd: "megaphone" },
    C: { ad: "Conscientiousness", tam: "Conscientiousness", eksen: "Calm pace + task/process focus", anahtar: "Data, quality, standard", ses: "Data!", obje: "📋", objeAd: "checklist" },
    S: { ad: "Steadiness", tam: "Steadiness", eksen: "Calm pace + people/relationship focus", anahtar: "Trust, support, harmony", ses: "Is everyone OK?", obje: "🫖", objeAd: "teapot" },
  },
};

// ── Stil adları ─────────────────────────────────────────────────────────────
// ONAYLI SET — ~/DISC/SomerenLabs_DISC_Referans_Eki.md §2. Örnek rapor PDF'lerinde
// geçmez, Ajlan'ın bilinçli tercihidir; denetimde ihlal sayılmaz.
// Anlatı metinlerinde bu adlar, boyut başlıklarında klasik DISC adları kullanılır.
export const STIL_ADLARI = {
  tr: {
    D: "Direct / Direk",
    I: "Influencer / İfadeci / İz Bırakan",
    S: "Steadfast / Sadık / Sabırlı",
    C: "Cautious / Ciddi",
  },
  en: {
    D: "Direct",
    I: "Influencer",
    S: "Steadfast",
    C: "Cautious",
  },
};
